import PropTypes from 'prop-types';
import { GENERATION_CATEGORIES_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJCategoryOptionCard from '../FJCategoryOptionCard';

import styles from './FJCategorySelector.module.less';

const FJCategorySelector = ({ onCategoryChange, selectedCategoryKey }) => {
    return (
        <div className={styles.step_form}>
            <h3 className={styles.category_title}>{FJLocalStore._('advance-ai-headshot-generator')}</h3>
            <p className={styles.category_description}>{FJLocalStore._('advance-ai-headshot-generator-description')}</p>
            <div className={styles.category_grid}>
                {GENERATION_CATEGORIES_OPTIONS.map(category => (
                    <FJCategoryOptionCard
                        key={category.key}
                        category={category}
                        isSelected={selectedCategoryKey === category.key}
                        onClick={onCategoryChange}
                    />
                ))}
            </div>
        </div>
    );
};

FJCategorySelector.propTypes = {
    selectedCategory: PropTypes.string.isRequired,
    onCategoryChange: PropTypes.func.isRequired,
    selectedCategoryKey: PropTypes.string.isRequired,
};

export default FJCategorySelector;
